import { render, staticRenderFns } from "./PostWidgets.vue?vue&type=template&id=042232a3&"
import script from "./PostWidgets.vue?vue&type=script&lang=js&"
export * from "./PostWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports